<div class="headerFlexW pr-4 m-3">
  <div class="content-block">
    <p class="bread-crumbs">Movimientos</p>
    <h2 class="">Listado de Movimientos</h2>
  </div>
</div>

<div class="content-block">
  <div class="dx-card responsive-paddings pt-2">
    <!-- Filters -->
    <div class="">
      <!---->
      <dx-form [(formData)]="filters" [colCount]="4" labelLocation="top">

        <!-- companyId -->
        <ng-container *ngIf="userData.level < 4">
          <dxi-item dataField="companyId" editorType="dxSelectBox"
            [editorOptions]="{ displayExpr: 'companyName', valueExpr:'id', items: companies, searchEnabled: true, value: null }">
            <dxo-label text="Empresa"></dxo-label>
          </dxi-item>
        </ng-container>

        <!-- Nombre -->
        <dxi-item dataField="name">
          <dxo-label text="Nombre"></dxo-label>
        </dxi-item>

        <!-- Apellido -->
        <dxi-item dataField="lastname">
          <dxo-label text="Apellido"></dxo-label>
        </dxi-item>

        <!-- email -->
        <dxi-item dataField="email">
          <dxo-label text="Email"></dxo-label>
          <dxi-validation-rule type="email" message="Email inválido"></dxi-validation-rule>
        </dxi-item>

        <dxi-item *ngIf="userData.level >= 4" itemType="empty" [colSpan]="1"></dxi-item>

        <!-- cardNumber -->
        <dxi-item dataField="cardNumber" [editorOptions]="cardNumberEditorOptions">
          <dxo-label text="Tarjeta"></dxo-label>
        </dxi-item>

        <!-- Date Start -->
        <dxi-item dataField="dateStart" dataType="date" [isRequired]="false">
          <dxo-label text="Fecha Inicio"></dxo-label>
          <dx-date-box displayFormat="shortdate" type="date" [(value)]="filters.dateStart"
            (onValueChanged)="getMovements($event)">
            <dx-validator>
              <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
            </dx-validator>
          </dx-date-box>
        </dxi-item>

        <!-- Date End -->
        <dxi-item dataField="dateEnd" dataType="date" [isRequired]="false">
          <dxo-label text="Fecha Fin"></dxo-label>
          <dx-date-box displayFormat="shortdate" type="date" [(value)]="filters.dateEnd"
            (onValueChanged)="getMovements($event)">
            <dx-validator>
              <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
            </dx-validator>
          </dx-date-box>
        </dxi-item>

        <dxi-item>
          <div class="flex justify-content-center">
            <dx-button text="Buscar" icon="find" type="default" (onClick)="getMovements()"></dx-button>
          </div>
        </dxi-item>

        <dxi-item>
          <div class="dx-field">
            <div class="dx-field-value">
              <dx-check-box [value]="isMovementsVouchers" text="Movimientos con comprobantes"
              (onValueChanged)="setMovementsVouchers($event.value)"></dx-check-box>
            </div>
          </div>
        </dxi-item>

      </dx-form>

    </div>
  </div>
</div>
<div class="content-block">
  <div class="dx-card responsive-paddings pt-2">

    <!-- Results -->
    <div class="mt-5">
      <dx-data-grid [dataSource]="movements" keyExpr="id" [showBorders]="true" [columnAutoWidth]="true" (onRowPrepared)="onRowPrepared($event)">
        <dxo-export [enabled]="true" [allowExportSelectedData]="true" fileName="Reporte de Movimientos ihunter"></dxo-export>
        <dxo-load-panel [enabled]="true"></dxo-load-panel>
        <dxo-paging [pageSize]="10"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 25, 50, 100]" [showInfo]="true">
        </dxo-pager>
        <!-- <dxi-column dataField="dateCreated" caption="Creada" cellTemplate="dateTemplate" alignment="center">
        </dxi-column> -->
        <dxi-column dataField="idMovimiento" caption="No." dataType="number" alignment="center"></dxi-column>
        <dxi-column dataField="Tarjeta" caption="Tarjeta" alignment="left" cellTemplate="TarjetaTemplate"></dxi-column>
        <dxi-column dataField="NombreComercio" caption="Comercio" alignment="left"></dxi-column>
        <dxi-column dataField="ClaveMovimientoDescripcion" caption="Movimiento" alignment="left"></dxi-column>
        <dxi-column dataField="ReferenciaNumerica" caption="Referencia" alignment="center"></dxi-column>
        <dxi-column dataField="dateCreated" caption="Fecha" dataType="date" format="dd/MM/yyyy hh:mm a"
          alignment="center"></dxi-column>
        <dxi-column dataField="Importe" caption="Importe" dataType="cureency" format="currency" alignment="right">
          <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
        </dxi-column>

        <div *dxTemplate="let data of 'TarjetaTemplate'">
          <i class="far fa-credit-card mr-2"></i>
          <span>**** **** **** {{data.value}}</span>
        </div>
        <dxo-master-detail [enabled]="true" template="url" ></dxo-master-detail>
        <div *dxTemplate="let data of 'url'">
          <div class="master-detail-caption" *ngFor="let item of parseFiles(data.data.urls); trackBy: trackByFn;">
            <a (click)="dowloadVoucher(item, $event)" [href]="item.url" target="_blank">
              <i class="fal fa-file-alt"></i>
              {{ item.name }}
            </a>
          </div> 
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>